import gql from 'graphql-tag';

export const setCompany360StatusMutation = gql`
    mutation setCompany360StatusMutation($id: ID!, $status: Status360!) {
        results: company360SetStatus(id: $id, newStatus: $status) {
            id
            status
        }
    }
`;
